import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { CheckboxIcon } from "@similarweb/ui-components";

const Container = styled.div<{ color: string }>`
    svg {
        path {
            fill: ${({ color }) => color};
        }
    }
`;

const { blue, carbon } = colorsPalettes;

export const Checkbox = ({ disabled = false, selected = false, semiSelected = false }) => {
    const color = selected || semiSelected ? blue[400] : carbon[200];
    return (
        <Container color={color}>
            <CheckboxIcon
                disabled={disabled}
                color={color}
                selected={selected}
                halfSelected={semiSelected}
            />
        </Container>
    );
};
